import { api, ApiResponse } from './api'
import { Role } from '../types/auth'

export interface CreateRoleRequest {
  name: string
  description?: string
  permissions: Record<string, any>
  isActive?: boolean
  menuIds?: number[]
}

export interface UpdateRoleRequest {
  name?: string
  description?: string
  permissions?: Record<string, any>
  isActive?: boolean
  menuIds?: number[]
}

export const roleService = {
  async getRoles(): Promise<Role[]> {
    const response = await api.get<ApiResponse<{ data: Role[], pagination: any }>>('/roles')
    return response.data.data.data
  },

  async getRoleById(id: number): Promise<Role> {
    const response = await api.get<ApiResponse<Role>>(`/roles/${id}`)
    return response.data.data
  },

  async createRole(data: CreateRoleRequest): Promise<Role> {
    const response = await api.post<ApiResponse<Role>>('/roles', data)
    return response.data.data
  },

  async updateRole(id: number, data: UpdateRoleRequest): Promise<Role> {
    try {
      const response = await api.patch<ApiResponse<Role>>(`/roles/${id}`, data)
      return response.data.data
    } catch (error) {
      console.error('Error updating role:', error)
      throw error
    }
  },

  async deleteRole(id: number): Promise<void> {
    await api.delete(`/roles/${id}`)
  }
}
